import React, { useState, useEffect } from "react";
import { baseURL } from "../utils/config";
import ProductsBannerListing from "../assets/images/productListingBannerNew.webp";
import ProductsBannerListingSmall from "../assets/images/productListingBannerSmallNew.webp";
import ButtonArrow from "../assets/images/button-arrow.svg";
import { Box, CircularProgress } from "@mui/material";
import { Helmet } from "react-helmet-async";
import axios from "axios";
import { useLocation, useNavigate } from "react-router-dom";

const ProductsListing = () => {
  const [partnerTab, setPartnerTab] = useState("company");
  const [isLoading, setIsLoading] = useState(true);
  const navigate = useNavigate();
  const [cards, setCards] = useState();
  const location = useLocation();
  const productId = location?.state?.productId;

  console.log(productId, "Data ");

  useEffect(() => {
    const getData = async () => {
      try {
        const response = await axios.get(
          `${baseURL}/api/product-details?filters[product_id][$eq]=${productId}&populate=*`
        );
        setCards(response.data.data);
      } catch (error) {
        console.error("Error fetching data: ", error);
      }
    };
    getData();
  }, [productId]);

  useEffect(() => {
    setIsLoading(true);
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 2000);

    return () => clearTimeout(timer);
  }, [productId]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  if (isLoading) {
    return (
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
          backgroundColor: "#f5f5f5",
        }}
      >
        <CircularProgress />
      </Box>
    );
  }

  const handleClickEnquiry = (title) => {
    const emailAddress = "salescso@uniklinger.com";
    const subject = `${title}'s Enquiry`;
    const body = `Hey, I wanted to know more about ${title}`;
    const mailtoUrl = `mailto:${encodeURIComponent(
      emailAddress
    )}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
    window.open(mailtoUrl);
  };

  return (
    <>
      <Helmet>
        <title>Products Listing</title>
        <meta
          itemProp="description"
          content="Uni Klinger's product range excels in simplicity, durability, reliability, and environmental consciousness."
        />
      </Helmet>
      <div className="fluid-container mt-[100px] flex justify-center flex-col items-center">
        <div
          className="banner-class relative text-center flex items-center "
          itemScope
          itemType="https://schema.org/Product"
        >
          <picture>
            {/* Small banner only for xs screens (max-width: 639px) */}
            <source
              media="(max-width: 430px)"
              srcSet={ProductsBannerListingSmall}
            />
            {/* Default banner for larger screens */}
            <img
              src={ProductsBannerListing}
              alt="Safety Valves"
              className="w-full xl:w-[1260px] xl:min-h-[332px] object-cover max-w-[100%] sm:max-h-[300px] md:max-h-[400px] rounded-md"
              itemProp="image"
            />
          </picture>
          {/* ✅ Gray overlay fully covering image */}
          <div className="absolute top-[40px] inset-0 bg-[#091920]/[0.6] rounded-md"></div>
          <div
            className="absolute text-white md:top-[25%] sm:top-[20%] xs:top-[20%] top-[10%] left-[5%] max-w-[90%] text-left"
            itemProp="name"
          >
            <h1 className="xs:text-[20px] xs:ml-5 text-3xl sm:text-4xl md:text-5xl text-left font-bold md:mb-4 sm:mb-4 mb-0">
              {cards?.[0]?.attributes?.product?.data?.attributes?.Title}
            </h1>
            <p className="xs:text-[12px] xs:ml-5 text-[10px] sm:text-lg md:text-2xl text-white mt-0 leading-tight">
              {cards?.[0]?.attributes?.product?.data?.attributes?.Description}
            </p>
          </div>
        </div>
        <div className="product-cards-container pt-50 flex justify-start items-center">
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-4 custom:grid-cols-3 gap-4 w-full">
            {cards?.map((product) => (
              <div
                key={product.id}
                className="product-listing-card flex flex-col items-start px-0 w-full sm:w-3/4 md:w-3/4 lg:w-full"
                itemProp="offers"
                itemScope
                itemType="https://schema.org/Offer"
              >
                <img
                  src={`${baseURL.replace(
                    /\/$/,
                    ""
                  )}/${product.attributes?.Thumbnail?.data?.attributes?.url?.replace(
                    /^\//,
                    ""
                  )}`}
                  alt={product?.attributes?.Title}
                  className="h-auto max-h-[170px] w-full object-contain"
                  itemProp="image"
                />
                <div
                  className="product-listing-card-title bg-white w-full text-center mb-10"
                  itemProp="name"
                >
                  {product?.attributes?.Title}
                </div>
                <div className="hover-buttons d-flex justify-around w-full p-2">
                  <a
                    href={`/products/${product?.attributes?.slug}`}
                    // onClick={() => navigate()}
                    className="view-more d-flex items-center w-full justify-center"
                  >
                    <span className="text-[12px] text-black text-center">
                      View More
                    </span>
                  </a>
                  <button
                    onClick={() =>
                      handleClickEnquiry(product?.attributes?.Title)
                    }
                    className="enquire text-center d-flex items-center w-full justify-center"
                  >
                    <span className="text-[12px] mr-1">Enquire Now</span>
                    <span>
                      <img
                        src={ButtonArrow}
                        alt="arrow"
                        width={10}
                        height={10}
                        className="mt-0"
                      />
                    </span>
                  </button>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </>
  );
};

export default ProductsListing;
